import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  tone?: 'light' | 'dark';
  align?: 'center' | 'left';
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  tone = 'light',
  align = 'center'
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className={align === 'center' ? 'mx-auto max-w-[820px] text-center' : 'max-w-[680px]'} data-id="element-242" data-mp="rx80rwf24tye">
      {eyebrow && <p className={`mb-3 text-xs font-bold uppercase tracking-[.2em] ${dark ? 'text-teal-light' : 'text-teal'}`} data-id="element-243" data-mp="n0rg5c72gxq2">
          {eyebrow}
        </p>}
      <h2 className={`font-display text-[36px] font-extrabold uppercase leading-[.95] tracking-[-.01em] sm:text-[52px] lg:text-[58px] ${dark ? 'text-white' : 'text-petrol'}`} data-id="element-244" data-mp="d9wsq4i33s31">
        {title}
      </h2>
      {description && <p className={`mt-4 text-base leading-relaxed sm:mt-5 sm:text-[17px] ${dark ? 'text-white/75' : 'text-slate'}`} data-id="element-245" data-mp="3vehts6f5clkz">{description}</p>}
    </div>;
}
export function Highlight({
  children,
  tone = 'light'
}: {
  children: React.ReactNode;
  tone?: 'light' | 'dark';
}) {
  return <span className={tone === 'dark' ? 'text-teal-light' : 'text-teal'} data-id="element-246" data-mp="1itc9ktbzu6ah">{children}</span>;
}